const isOpen = ref(false);

let pendingResolve: (() => void) | null = null;
let pendingReject: ((reason?: unknown) => void) | null = null;

function isReauthRequired(error: unknown): boolean {
  const err = error as { statusCode?: number; data?: { data?: { code?: string } } };
  return err?.statusCode === 403 && err?.data?.data?.code === "REAUTH_REQUIRED";
}

function openReauthModal(): Promise<void> {
  isOpen.value = true;
  return new Promise((resolve, reject) => {
    pendingResolve = resolve;
    pendingReject = reject;
  });
}

function completeReauth(): void {
  isOpen.value = false;
  pendingResolve?.();
  pendingResolve = null;
  pendingReject = null;
}

function cancelReauth(): void {
  isOpen.value = false;
  pendingReject?.(new Error("Reauth cancelled"));
  pendingResolve = null;
  pendingReject = null;
}

async function withReauth<T>(fn: () => Promise<T>): Promise<T> {
  try {
    return await fn();
  } catch (error) {
    if (isReauthRequired(error)) {
      await openReauthModal();
      return await fn();
    }
    throw error;
  }
}

export function useReauthModal() {
  return { isOpen: readonly(isOpen), withReauth, completeReauth, cancelReauth };
}
